import Filtering from '../components/Filtering';
import ProductList from '../components/ProductList';

export default class Search {
  constructor(section) {
    this.el = section.el;
    this.sectionId = section.id;
    this.filters = this.el.querySelector('[data-faceted-filters]');

    this.filtering = null;

    if (this.filters) {
      this.filtering = new Filtering(this.el);
    }

    this.productList = new ProductList({
      el: this.el,
      id: `shopify-section-${this.sectionId}`,
    });
  }

  onSectionUnload() {
    if (this.filtering) {
      this.filtering.unload();
    }

    this.productList.unload();
  }
}
